module.exports = __webpack_public_path__ + "static/media/no-image.e09e3090.jpg";